import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import Swal from 'sweetalert2';
import { LoginService } from '../../login/login.service';
import { PageBusquedaObject, PolService } from '../ctb-pol/ctb-pol.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-poliza-cierre',
  templateUrl: './poliza-cierre.component.html',
  styleUrls: ['./poliza-cierre.component.css'],
  providers: [PolService, LoginService]
})
export class PolizaCierreComponent implements OnInit {
  public tpolList: any[] = [];
  datosPoliza: any = {idEmp: 0, idSuc: 0, idTpol: 0, concepto: '', idCtaCapital: null, anio: 2020};
  criteriaSearch: any | undefined = {};
  cuentas: any[] = [];
  items: any[] = [];
    busqueda: PageBusquedaObject = new PageBusquedaObject();
  tipo: String = '';
  @ViewChild('titulo') title: ElementRef;
  constructor(public loginService: LoginService, private service: PolService, private router: Router,private route: ActivatedRoute) {
  }
  ngOnInit() {
    
    this.route.queryParams.subscribe(params => {
   this.tipo = params['tipo'];
});
    this.datosPoliza.idEmp = this.loginService.empresa as number;
    this.datosPoliza.idSuc = this.loginService.sucursal as number;
    this.cargarTiposPolizasGrupos();
  }

  cargarTiposPolizasGrupos() {
    this.service.tpolGrupoGet(this.loginService.empresa).subscribe(response => {
      this.tpolList = response;
      this.datosPoliza.idTpol = this.tpolList[0].id
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      console.log(err);
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      });
    });
  }

  buscarCuenta(campo: String, busqueda: String) {
    switch (campo) {
      case 'cuenta_capital':
        this.criteriaSearch['cuenta_nombre'] = busqueda;
        this.criteriaSearch['tipo'] = 3;
        break;
    }
    this.criteriaSearch['nivel'] = 4;
    this.criteriaSearch['emp'] = this.loginService.empresa;
    this.service.postBusqueda(this.criteriaSearch).subscribe(response => {
      this.cuentas = response.contenido;
      if (this.cuentas != null && this.cuentas.length === 1) {
        switch (campo) {
          case 'cuenta_capital':
            if (this.criteriaSearch['cuenta_nombre'].toLowerCase() === this.cuentas[0].cuenta.toLowerCase()
              || this.criteriaSearch['cuenta_nombre'].toLowerCase() === this.cuentas[0].nombre.toLowerCase()) {
              this.datosPoliza.idCtaCapital = this.cuentas[0].id;
            }
            break;
        }
      }
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire('TNK Ledger', err.error.mensaje, 'error');
    });
  }

  navegador(): String {
    if ((navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) != -1) {
      return 'Opera';
    } else if (navigator.userAgent.indexOf('Chrome') != -1) {
      return 'Chrome';
    } else if (navigator.userAgent.indexOf('Safari') != -1) {
      return 'Safari';
    } else if (navigator.userAgent.indexOf('Firefox') != -1) {
      return 'Firefox';
    } else {
      return 'unknown';
    }
  }
crear(){
  
    this.datosPoliza.anio = parseInt(localStorage.getItem('ejercicio_vigente')+ '') as number;
    this.datosPoliza.periodo = parseInt(localStorage.getItem('periodo_vigente')+ '') as number;
    console.log(this.datosPoliza);
  if(this.tipo == 'Ejercicio'){
    this.crearPolizaCierreEjercicio();
  } else if (this.tipo == 'Periodo'){
this.crearPolizaCierrePeriodo();
  }
}
  crearPolizaCierreEjercicio() {
    this.service.polizaCierreEjercicio(this.datosPoliza).subscribe(
      response => {
        Swal.fire('TNK Ledger', response.mensaje, 'success');
        this.router.navigate(['/contabilidad/proceso/ctb-pol']);
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        });
      }
    );
  }

    crearPolizaCierrePeriodo() {
    this.service.polizaCierrePeriodo(this.datosPoliza).subscribe(
      response => {
        Swal.fire('TNK Ledger', response.mensaje, 'success');
        this.router.navigate(['/contabilidad/proceso/ctb-pol']);
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        });
      }
    );
  }

  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }

   cargarCatalogo() {
    this.datosPoliza.anio = parseInt(localStorage.getItem('ejercicio_vigente')+ '') as number;
    this.datosPoliza.periodo = parseInt(localStorage.getItem('periodo_vigente')+ '') as number;
    this.busqueda.criteriaSearch['ano'] = this.datosPoliza.anio;
    this.busqueda.criteriaSearch['emp'] = this.loginService.empresa;
      this.busqueda.criteriaSearch['mes'] = this.datosPoliza.periodo+"";
 
  
    console.log(this.busqueda);
    this.service.polCatalogo(this.busqueda).subscribe(response => {
      this.items = response.contenido.content;
      console.log(response);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }

      limpiarBusqueda(): void {
    this.busqueda.sort = false;
    this.busqueda.criteriaSearch = {};
    this.busqueda.pageNumber = 1;
    this.busqueda.page1= true;
    this.filtroDeBusqueda('0', 'tpol');
    this.filtroDeBusqueda('2', 'estatus');
    this.cargarCatalogo();
  }
    buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 1;
    this.cargarCatalogo();
  }



  abrirPoliza(id: number) {
  const params = new URLSearchParams();
  params.set('id', id.toString()); // tu parámetro

  const url = `/#/contabilidad/proceso/ctb-pol?${params.toString()}`;

    const width = window.screen.width * 0.8;   // ancho de la ventana (50%)
const height = window.screen.height * 0.8; // alto de la ventana (50%)

// Calculamos la posición centrada
const left = (window.screen.width - width) / 2;
const top = (window.screen.height - height) / 2;

const ventana = window.open(
  url,
  'VisualizarCuenta',
  `top=${top},left=${left},width=${width},height=${height},resizable=yes,scrollbars=yes`
);
}
}
